import { render, staticRenderFns } from "./colsTables.vue?vue&type=template&id=1ce07b94&"
import script from "./colsTables.vue?vue&type=script&lang=js&"
export * from "./colsTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports